// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__34cZZ","left":"InfoRow_left__3vErI"};